export default __webpack_public_path__ + "static/media/c2caftermovie.939c6285.mp4";